import React from "react";
import { Box, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import MarketingAuthFormShell from "../../components/marketing/MarketingAuthFormShell";
import NotFoundPageContent from "../../components/marketing/NotFoundPageContent";
import Seo from "../../seo/Seo";
import { marketingAuthCardSx } from "../../constants/marketingTokens";

export default function PublicNotFound({ darkMode, setDarkMode }) {
  const { t: tSeo } = useTranslation("seo");

  return (
    <MarketingAuthFormShell
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      maxWidth={640}
    >
      <Seo
        title={tSeo("notFound.title")}
        description={tSeo("notFound.description")}
        keywords={tSeo("notFound.keywords")}
        noindex
      />
      <NotFoundPageContent variant="public" />
    </MarketingAuthFormShell>
  );
}

/** Panel içi 404 kartı — doctor/tenant layout'ları için */
export function PanelNotFoundCard({ variant }) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 2, sm: 3 },
        minHeight: "100%",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          ...marketingAuthCardSx,
          width: "100%",
          maxWidth: 640,
          p: { xs: 3, sm: 5, md: 6 },
        }}
      >
        <NotFoundPageContent variant={variant} />
      </Paper>
    </Box>
  );
}
